'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Renren';

var EntypoRenren = function EntypoRenren(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M8.468,0.865C4.117,1.594,0.8,5.377,0.8,9.936c0,2.266,0.82,4.338,2.179,5.941c3.221-1.559,5.472-5.086,5.489-9.191V0.865z M10.002,12.258c-0.573,2.373-2.285,4.4-4.418,5.748C6.894,18.725,8.4,19.135,10,19.135c1.602,0,3.108-0.41,4.418-1.129C12.285,16.658,10.574,14.631,10.002,12.258z M11.535,6.643c0,4.123,2.256,7.668,5.487,9.234c1.358-1.603,2.178-3.676,2.178-5.941c0-4.559-3.315-8.34-7.665-9.07V6.643z' })
    );
};

exports.default = EntypoRenren;
module.exports = exports['default'];